import React from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

// Sprint 8.A.2 — Wrapper für Frank's Coach-Stimme.
// Wird in allen 4 Sections + Header + CTA verwendet.
// Subtile Fade-In Animation für sanften emotionalen Anker.

export default function CockpitCoachVoice({ text, variant = "section", testId }) {
  if (!text) return null;

  if (variant === "header") {
    return (
      <motion.p
        initial={{ opacity: 0, y: 4 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        data-testid={testId || "coach-voice-header"}
        className="mt-1 text-sm text-slate-600 leading-relaxed"
      >
        {text}
      </motion.p>
    );
  }

  if (variant === "cta") {
    return (
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.4 }}
        data-testid={testId || "coach-voice-cta"}
        className="text-sm font-semibold text-white opacity-95"
      >
        {text}
      </motion.p>
    );
  }

  // section default
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      data-testid={testId || "coach-voice"}
      className="mt-2 flex items-start gap-1.5 text-xs italic text-slate-500 leading-relaxed"
    >
      <MessageCircle className="w-3 h-3 text-[#4563BB] flex-shrink-0 mt-0.5" />
      <span>{text}</span>
    </motion.div>
  );
}
